import { Button, IconMediaBlock, type IconNames, Row, TextPassage } from '@petsmart-ui/sparky';
import type { AriaRole } from 'react';

type SpecialtyLineItemProps = {
    text: string;
    onClickAction: () => void;
    role: AriaRole;
    ariaLabel: string;
    icon?: IconNames;
    shouldShowDetailsButton?: boolean;
};

export const SpecialtyLineItem = ({
    text,
    icon,
    role,
    ariaLabel,
    onClickAction,
    shouldShowDetailsButton = true,
}: SpecialtyLineItemProps) => {
    return (
        <Row className="product-specialty__row">
            <IconMediaBlock
                className="product-specialty__line-item"
                iconSize="md"
                verticalAlign="center"
                iconName={icon}
                variant="bare"
            >
                <TextPassage>
                    <span>{text} </span>
                    {shouldShowDetailsButton && (
                        <Button
                            variant="link"
                            text="Details"
                            onClick={onClickAction}
                            role={role}
                            aria-label={ariaLabel}
                        />
                    )}
                </TextPassage>
            </IconMediaBlock>
        </Row>
    );
};
